import { ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useGetCategoriesQuery } from './category.api.slice';
import { ICategoryType } from './category.d';
import useSearchParamActions from '@/customHooks/useSearchParamActions';

function CategoryFilter() {
  const { data: categories, isLoading: isLoadingPostCategories } =
    useGetCategoriesQuery({ type: ICategoryType.POST });
  const { removeSearchParam, appendSearchParam } = useSearchParamActions();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="gap-2">
          Category
          <ChevronDown className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="max-h-[400px] overflow-y-auto">
        {isLoadingPostCategories ? (
          <div className="flex items-center justify-center">
            <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-gray-200" />
          </div>
        ) : (
          <DropdownMenuItem
            onClick={() => {
              removeSearchParam('category');
            }}
          >
            All
          </DropdownMenuItem>
        )}
        {categories?.map((category) => (
          <DropdownMenuItem
            key={category._id}
            onClick={() => {
              appendSearchParam('category', category.name);
            }}
          >
            {category.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default CategoryFilter;
